'use client'

import { BrandCategories } from '@/screens/catalog-brands/ui/BrandCategories/BrandCategories'
import { BrandsItem } from '@/screens/Home/page/types/types'

type Props = {
	categories: BrandsItem[]
}

const BrandPageContent = ({ categories }: { categories: BrandsItem[] }) => {
	return <BrandCategories categories={categories} />
}

export function BrandClient({ categories }: Props) {
	return <BrandPageContent categories={categories} />
}
